/**
 * Extract a user-friendly error message from an API error response.
 * Handles Laravel validation errors, generic message responses, and network errors.
 */
export function getErrorMessage(error, fallback = "An unexpected error occurred. Please try again.") {
  if (error?.response?.data) {
    const data = error.response.data;

    // Laravel validation errors: { errors: { field: ["msg1"], ... } }
    if (data.errors && typeof data.errors === "object") {
      return Object.values(data.errors).flat().join("\n");
    }

    // Generic Laravel error: { message: "..." }
    if (data.message) {
      return data.message;
    }
  }

  // Network / timeout errors
  if (error?.message) {
    return error.message;
  }

  return fallback;
}
